
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { mapState } from "vuex";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import { ALL_STATUSES } from "@/constants/applicationStatuses";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Id", value: "id" },
        { text: "Applicant name", value: "fullName" },
        { text: "Business name", value: "businessName" },
        { text: "Created date", value: "createdDate" },
        { text: "Updated date", value: "updatedDate" },
        { text: "Status", value: "status" }
      ],
      applicationStatuses: ALL_STATUSES
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.application.dataTables.allApplications.pagination;
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_ALL_APPLICATIONS_PAGINATION),
          value
        );
      }
    },
    statusFilters: {
      get(): any {
        return (
          store.state.application.dataTables.allApplications.statusFilters ||
          this.applicationStatuses
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(
            APPLICATION.MUTATIONS.SET_ALL_APPLICATIONS_DATA_TABLE_STATUS_FILTERS
          ),
          value
        );
      }
    },
    ...mapState({
      applicationsList: (state: IRootState) =>
        state.application.applicationsList,
      totalApplications: (state: IRootState) =>
        state.application.applicationsListTotal
    }),
    route: () => ROUTE_NAMES.APPLICATION_DETAIL
  },
  methods: {
    async onSearch() {
      this.isLoading = true;

      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION_LIST),
        {
          statuses: this.statusFilters,
          pagination: this.pagination
        }
      );

      this.isLoading = false;
    },
    async onStatusChange() {
      // Reset to page 1 before searching
      this.pagination.page = 1;
      await this.onSearch();
    },
    goToDetails(id: any) {
      this.$router.push({
        name: ROUTE_NAMES.APPLICATION_DETAIL,
        params: { id }
      });
    }
  }
});
